import { useLocation } from 'react-router'

export const useUtmParams = () => {
  const { search } = useLocation()
  const query = new URLSearchParams(search)

  const utm = Array.from(query.entries()).reduce<{ [key: string]: string }>(
    (state, [key, value]) => {
      if (key.includes('utm_')) {
        state[key] = value
      }

      return state
    },
    {}
  )

  sessionStorage.setItem('utm', JSON.stringify(utm))
}
